module.exports = __webpack_public_path__ + "img/morePeople.47f03416.png";